import scgFontBold from "@assets/fonts/SCG-Bold.otf";
import scgFontItalic from "@assets/fonts/SCG-Italic.otf";
import scgFontLig from "@assets/fonts/SCG-Lig.otf";
import scgFont from "@assets/fonts/SCG-Reg.otf";
import { Theme } from "@material-ui/core/styles";
import { datePickerOverrides } from "@saleor/themes/datepicker";

import { inputOverrides } from "./input";
import Palette from "./palette";

const fontRegular = {
  fontFamily: "ScgFont",
  fontStyle: "normal",
  fontWeight: 400,
  src: ` url(${scgFont})`
};
const fontItalic = {
  fontFamily: "ScgFont",
  fontStyle: "italic",
  fontWeight: 400,
  src: ` url(${scgFontItalic})`
};
const fontBold = {
  fontFamily: "ScgFont",
  fontStyle: "normal",
  fontWeight: 700,
  src: ` url(${scgFontBold})`
};
const fontLight = {
  fontFamily: "ScgFont",
  fontStyle: "normal",
  fontWeight: 300,
  src: ` url(${scgFontLig})`
};
const themeOverrides: Partial<Theme> = {
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [fontRegular, fontBold, fontItalic, fontLight],
        div: {
          "&::-webkit-scrollbar": {
            width: "14px",
            background: "#FFFFFF"
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: 10
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#CCCCCC",
            borderRadius: 10,
            border: "4px solid #FFFFFF",
            minHeight: "30px",
            width: "6px"
          },
          "&::-webkit-scrollbar-button": {
            width: 14,
            height: 14,
            backgroundSize: "100%"
          },
          "&::-webkit-scrollbar-button:end": {
            display: "block"
          },
          "&::-webkit-scrollbar-button:start": {
            display: "none"
          },
          "&::-webkit-scrollbar-button:horizontal:increment": {
            border: `0.5px solid ${Palette.grey[300]}`,
            backgroundSize: "14px 14px",
            background:
              "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='white'/%3E%3Cpath d='M4 11V3L10 7L4 11Z' fill='%23999999'/%3E%3C/svg%3E%0A\")",
            "&:hover": {
              background:
                "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='%23E0E0E0'/%3E%3Cpath d='M4 11V3L10 7L4 11Z' fill='%23999999'/%3E%3C/svg%3E%0A\")"
            }
          },
          "&::-webkit-scrollbar-button:horizontal:decrement": {
            border: `0.5px solid ${Palette.grey[300]}`,
            borderRight: "none",
            backgroundSize: "14px 14px",
            background:
              "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='white'/%3E%3Cpath d='M10 11V3L4 7L10 11Z' fill='%23999999'/%3E%3C/svg%3E%0A\")",
            "&:hover": {
              background:
                "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='%23E0E0E0'/%3E%3Cpath d='M10 11V3L4 7L10 11Z' fill='%23999999'/%3E%3C/svg%3E%0A\")"
            }
          },
          "&::-webkit-scrollbar-button:vertical:increment": {
            border: `0.5px solid ${Palette.grey[300]}`,
            borderTop: "none",
            backgroundSize: "14px 14px",
            background:
              "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='white'/%3E%3Cpath d='M11 4L3 4L7 10L11 4Z' fill='%23999999'/%3E%3C/svg%3E%0A\")",
            "&:hover": {
              background:
                "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='%23E0E0E0'/%3E%3Cpath d='M11 4L3 4L7 10L11 4Z' fill='%23999999'/%3E%3C/svg%3E%0A\")"
            }
          },
          "&::-webkit-scrollbar-button:vertical:decrement": {
            border: `0.5px solid ${Palette.grey[300]}`,
            backgroundSize: "14px 14px",
            background:
              "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='white'/%3E%3Cpath d='M11 10L3 10L7 4L11 10Z' fill='%23999999'/%3E%3C/svg%3E%0A\")",
            "&:hover": {
              background:
                "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' fill='%23E0E0E0'/%3E%3Cpath d='M11 10L3 10L7 4L11 10Z' fill='%23999999'/%3E%3C/svg%3E%0A\")"
            }
          }
        },
        body: {
          "& *": {
            fontFamily: "ScgFont, sans-serif",
            letterSpacing: 0
          },
          "&::-webkit-scrollbar": {
            width: "14px",
            background: "#FFFFFF"
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: 10
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#CCCCCC",
            borderRadius: 10,
            border: "4px solid #FFFFFF",
            width: "6px"
          }
        }
      }
    },
    MuiTable: {
      root: {
        borderCollapse: "initial",
        fontFamily: "ScgFont, sans-serif"
      }
    },
    MuiTableCell: {
      body: {
        paddingBottom: 8,
        paddingTop: 8,
        fontFamily: "ScgFont, sans-serif",
        fontSize: 14
      },
      root: {
        height: 56,
        paddingBottom: 4,
        paddingTop: 4,
        paddingLeft: 0,
        borderBottom: "none"
      }
    },
    MuiTypography: {
      root: {
        "&&&": {
          fontFamily: "ScgFont, sans-serif",
          letterSpacing: 0
        }
      },
      body1: {
        color: Palette.grey[900],
        fontSize: "1.8rem",
        fontWeight: 400,
        lineHeight: "24px"
      },
      h3: {
        fontSize: "3.2rem",
        lineHeight: "42px",
        fontWeight: 700
      },
      h5: {
        fontSize: "2.5rem",
        lineHeight: "3.2rem",
        fontWeight: 700,
        color: Palette.grey[900]
      },
      h6: {
        fontSize: "2rem",
        lineHeight: "26px",
        fontWeight: 700,
        color: Palette.grey[900]
      },
      subtitle1: {
        fontWeight: 700,
        fontSize: "1.8rem",
        lineHeight: "28px"
      },
      body2: {
        fontSize: "1.6rem",
        fontWeight: 400,
        lineHeight: "24px"
      },
      subtitle2: {
        fontWeight: 700,
        fontSize: "1.6rem",
        lineHeight: "24px"
      }
    },
    MuiButton: {
      root: {
        border: "none",
        padding: "1.2rem 1.6rem",
        "& .MuiSvgIcon-root": {
          marginRight: 10
        },
        fontSize: 18,
        lineHeight: "24px"
      },
      label: {
        fontWeight: 400
      },
      containedPrimary: {
        background: `${Palette.scgPrimary.main} !important`,
        color: "#FFF !important",
        border: "none",
        "&:hover": {
          background: "#BF0000 !important"
        },
        "&:active": {
          outline: `3px solid rgba(255, 38, 0, 1)`
        }
      },
      outlinedPrimary: {
        background: "#FFF !important",
        color: Palette.scgPrimary.main,
        borderColor: `${Palette.scgPrimary.main}`,
        "&:hover": {
          color: `${Palette.error.light} !important`,
          background: `${Palette.scgPrimary.hover} !important`,
          border: `1px solid ${Palette.error.light} !important`
        },
        "&:active": {
          outline: `3px solid rgba(255, 205, 197, 1)`
        },
        "& .MuiTypography-root": {
          color: Palette.scgPrimary.main
        },
        "&.Mui-disabled": {
          color: `${Palette.grey[400]} !important`,
          borderColor: `${Palette.grey[300]} !important`,
          "& .MuiTypography-root": {
            color: "inherit"
          }
        }
      },
      outlinedSecondary: {
        color: Palette.info.main,
        borderColor: Palette.info.main,
        padding: "12px",
        borderRadius: "4px",
        "&:hover": {
          backgroundColor: "rgba(0, 159, 184, 0.05) !important",
          borderColor: Palette.info.main
        },
        "&:active": {
          outline: "rgba(1, 178, 237, 0.32) solid 3px"
        }
      },
      containedSecondary: {
        backgroundColor: Palette.info.main,
        color: "white",
        padding: "12px",
        borderRadius: "4px",
        border: "none",
        "&:hover": {
          backgroundColor: Palette.info.dark
        },
        "&:active": {
          outline: "rgba(1, 178, 237, 0.32) solid 3px"
        },
        "&:focus": {
          backgroundColor: Palette.info.main
        }
      },
      contained: {
        "&.gradient": {
          background: `${Palette.gardient.default} !important`,
          color: "#FFF",
          border: "none",
          "&:hover": {
            color: "#FFF",
            background: `${Palette.gardient.hover} !important`
          },
          "&:active": {
            outline: "rgba(1, 178, 237, 0.32) solid 3px"
          }
        },
        "&.Mui-disabled": {
          background: `${Palette.grey[300]} !important`,
          color: "#FFF !important"
        },
        "&.defaultB": {
          background: Palette.grey[900],
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
            background: `${Palette.grey[700]} !important`
          },
          "&:active": {
            outline: `${Palette.grey[900]} solid 3px`
          },
          "& .MuiTypography-root": {
            color: "#FFFFFF"
          }
        },
        "& .MuiTypography-root": {
          color: "#FFFFFF"
        }
      },
      outlined: {
        "&.gradient": {
          background: "#FFF",
          color: `${Palette.purple.main} !important`,
          borderColor: `${Palette.purple.main} !important`,
          "&:hover": {
            color: "#FFF",
            background: "rgba(253, 0, 69, 0.05)"
          },
          "&:active": {
            outline: "rgba(1, 178, 237, 0.32) solid 3px"
          },
          "& .MuiTypography-root": {
            color: `${Palette.purple.main} !important`
          }
        },
        "&.defaultB": {
          background: "#FFF",
          color: `${Palette.grey[900]} !important`,
          border: `solid 1px ${Palette.grey[900]}`,
          "&:hover": {
            color: Palette.grey[900],
            background: `${Palette.grey[200]} !important`
          },
          "&:active": {
            outline: "rgba(0, 0, 0, 0.16) solid 3px"
          },
          "& .MuiTypography-root": {
            color: Palette.grey[900]
          },
          "&.Mui-disabled": {
            color: `${Palette.grey[400]} !important`,
            borderColor: `${Palette.grey[300]} !important`,
            "& .MuiTypography-root": {
              color: "inherit"
            }
          }
        },
        "&.Mui-disabled": {
          background: `white !important`,
          color: `${Palette.grey[400]} !important`,
          border: `1px solid ${Palette.grey[300]}`,
          "&&": {
            border: `1px solid ${Palette.grey[300]}`
          }
        },
        "& .MuiTypography-root": {
          color: Palette.info.main
        }
      }
    },
    ...inputOverrides(),
    ...datePickerOverrides(),
    MuiTableRow: {
      head: {
        background: "rgba(212, 244, 248, 0.8)"
      },
      root: {
        background: "white",
        "&:nth-child(even)": {
          background: "#F2FAFB"
        },
        "&:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer)": {
          backgroundColor: "#E6F6F8 !important",
          position: "relative"
        },
        "&:before": {
          content: "''"
        },
        "&:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer):before": {
          position: "absolute",
          content: "''",
          width: 4,
          height: "100%",
          backgroundColor: Palette.info.main
        },
        "&$selected": {
          backgroundColor: Palette.background.default,
          "&:nth-child(even)": {
            background: "#F2FAFB"
          }
        }
      }
    },
    MuiTableHead: {
      root: {
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 700,
        color: Palette.grey["600"],
        borderBottom: `2px solid ${Palette.grey[300]}`,
        "& .MuiTableCell-head": {
          color: Palette.grey[900],
          fontWeight: 700,
          background: "#D4F4F8"
        },
        "&:hover": {
          background: "#D4F4F8 !important"
        }
      }
    },
    MuiList: {
      root: {
        "&.custom-select": {
          "&::-webkit-scrollbar": {
            width: "10px",
            backgroundColor: " #f5f5f5"
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: "8px",
            backgroundColor: "#f5f5f5"
          },
          "&::-webkit-scrollbar-thumb": {
            minHeight: "15px",
            borderRadius: "8px",
            backgroundColor: "#babac0",
            "&:hover": {
              backgroundColor: " #a0a0a5"
            }
          },
          "& .MuiListItem-root": {
            justifyContent: "flex-start",
            fontFamily: "ScgFont, sans-serif",
            cursor: "pointer",
            color: Palette.grey[900],
            fontSize: "1.4rem",
            "&:hover": {
              backgroundColor: `${Palette.background.default} !important`,
              color: Palette.info.main
            }
          },
          "& .MuiListItem-root.Mui-selected": {
            backgroundColor: "#EBF1FF !important",
            color: Palette.info.main,
            fontWeight: "400"
          },
          "& .MuiMenuItem-root.Mui-selected:hover": {
            backgroundColor: "#EBF1FF !important",
            color: Palette.info.main,
            fontWeight: "400"
          },
          "& .MuiMenuItem-root.Mui-selected:focus": {
            backgroundColor: `#EBF1FF !important`,
            color: Palette.info.main
          },
          maxHeight: 334,
          overflowY: "auto"
        },
        padding: 5,
        borderRadius: 4,
        boxShadow:
          "0px 0px 0px 1px rgba(152, 161, 179, 0.1), 0px 15px 35px -5px rgba(17, 24, 38, 0.2), 0px 5px 15px rgba(0, 0, 0, 0.08)",
        fontFamily: "ScgFont",
        "& .MuiListItem-root": {
          justifyContent: "center",
          color: Palette.grey[700],
          fontSize: 14
        },
        "& .MuiListItem-root.Mui-selected": {
          backgroundColor: `${Palette.info.main} !important`,
          color: "white",
          fontWeight: "400",
          borderRadius: 4
        },
        "& .MuiMenuItem-root.Mui-selected:hover": {
          backgroundColor: `${Palette.info.main} !important`,
          color: "white",
          fontWeight: "400",
          borderRadius: 4
        },
        "& .MuiMenuItem-root.Mui-selected:focus": {
          backgroundColor: `${Palette.info.main} !important`,
          color: "white",
          fontWeight: "400",
          borderRadius: 4
        },
        "& .MuiListItem-root[data-testid=rowNumberOption]": {
          cursor: "pointer"
        }
      }
    },
    MuiRadio: {
      colorPrimary: {
        "&.Mui-checked": {
          color: Palette.info.main
        },
        "&$disabled": {
          "&&": {
            color: Palette.grey[400]
          }
        }
      },
      root: {
        "&:hover": {
          color: Palette.info.main
        },
        "& > span::before": {
          background: "#C2EDFB !important",
          width: "18px !important",
          height: "18px !important"
        }
      }
    },
    MuiCheckbox: {
      root: {
        padding: 0,
        margin: 14,
        "& .MuiIconButton-label": {
          "&:before": {
            backgroundColor: "transparent"
          },
          background: "transparent"
        },
        "& .MuiSvgIcon-fontSizeSmall": {
          width: 16,
          height: 16
        }
      },
      colorPrimary: {
        color: Palette.grey[500],
        "&$checked": {
          color: Palette.info.main
        },
        "&$disabled": {
          "&&": {
            color: Palette.grey[400]
          }
        },
        "&:hover": {
          color: Palette.info.main,
          boxShadow:
            "0px 1px 1px rgb(0 0 0 / 10%), 0px 0px 0px 1px rgb(70 79 96 / 16%), 0px 0px 0px 4px rgb(1 178 237 / 36%), 0px 2px 5px rgb(89 96 120 / 10%)",
          borderRadius: 4
        }
      },
      indeterminate: {
        color: `${Palette.info.main} !important`
      }
    },
    MuiSnackbar: {
      root: {
        "& .MuiAlert-filledSuccess": {
          background: Palette.gardient.default,
          boxShadow: "0px 4px 12px rgb(0 0 0 / 24%)",
          borderRadius: 6
        },
        "& .MuiAlert-filledError": {
          background: Palette.gardient.default,
          boxShadow: "0px 4px 12px rgb(0 0 0 / 24%)",
          borderRadius: 6
        }
      }
    },
    MuiBadge: {
      colorPrimary: {
        backgroundColor: Palette.purple.main
      }
    },
    MuiFormLabel: {
      root: {
        "&&&": {
          fontFamily: "inherit",
          letterSpacing: "inherit"
        }
      }
    },
    MuiInputBase: {
      root: {
        "&&&": {
          fontFamily: "inherit",
          letterSpacing: "inherit"
        }
      }
    },
    MuiDialog: {
      root: {
        "& .MuiDialogContent-root": {
          margin: 0,
          padding: "24px 24px 5px 24px"
        }
      },
      paper: {
        "&::-webkit-scrollbar": {
          width: "14px",
          background: "#FFFFFF"
        },
        "&::-webkit-scrollbar-track": {
          borderRadius: 10
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#CCCCCC",
          borderRadius: 10,
          border: "4px solid #FFFFFF",
          width: "6px"
        }
      }
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "transparent !important"
        }
      },
      root: {
        "&$disabled": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  palette: Palette
};
export default themeOverrides;
